var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "z-page",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { "margin-top": "20px" },
          attrs: { "separator-class": "el-icon-arrow-right" },
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v("首页"),
          ]),
          _c("el-breadcrumb-item", { attrs: { to: { path: "/warehouse" } } }, [
            _vm._v("仓储"),
          ]),
          _c("el-breadcrumb-item", [_vm._v("货架查询")]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("el-row", { attrs: { gutter: 30, span: 24 } }, [
            _c(
              "div",
              { staticClass: "container info-card" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "search-form",
                    attrs: {
                      inline: true,
                      rules: _vm.validateForm,
                      model: _vm.searchForm,
                      "label-width": "90px",
                    },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return (() => {}).apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "货架号", prop: "shelf_code" } },
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "货架号" },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.searchShelfPackages.apply(
                                null,
                                arguments
                              )
                            },
                          },
                          model: {
                            value: _vm.searchForm.shelf_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "shelf_code", $$v)
                            },
                            expression: "searchForm.shelf_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "z-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.searchShelfPackages },
                          },
                          [_vm._v("查询")]
                        ),
                        _vm.isWechat
                          ? _c(
                              "z-button",
                              {
                                attrs: { type: "default" },
                                on: { click: _vm.scanBarcode },
                              },
                              [_vm._v("扫码")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    staticClass: "ordering-list",
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.shelfPackagesList },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "package_attr_num", label: "包裹单号" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-link",
                                {
                                  attrs: {
                                    underline: false,
                                    type: "primary",
                                    href: `/dashboard?logistics_code=${scope.row.package_attr_num}`,
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.package_attr_num))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "shelf_code", label: "货架号" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "package_attr_status", label: "包裹状态" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.package_attr_status == 1
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: "success",
                                        size: "medium",
                                      },
                                    },
                                    [_vm._v("正常")]
                                  )
                                : scope.row.package_attr_status == 2
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "medium",
                                      },
                                    },
                                    [_vm._v("已创建")]
                                  )
                                : _c(
                                    "el-tag",
                                    {
                                      attrs: { type: "danger", size: "medium" },
                                    },
                                    [_vm._v("已取消")]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "package_attr_status_pay",
                        label: "支付状态",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.package_attr_status_pay === 1
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: "success",
                                        size: "medium",
                                      },
                                    },
                                    [_vm._v("已支付")]
                                  )
                                : _c(
                                    "el-tag",
                                    {
                                      attrs: { type: "danger", size: "medium" },
                                    },
                                    [_vm._v("未支付")]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "created",
                        label: "上架时间",
                        width: "180",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.created
                                ? _c("div", [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            scope.row.created
                                          )
                                        )
                                      ),
                                    ]),
                                  ])
                                : _c("div", [_vm._v("-")]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "ctrl-btn" }, [
        _c("div", { staticClass: "total" }, [
          _vm._v(
            "总数：" + _vm._s(_vm.shelfPackagesList.length || "-") + "个包裹"
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }